import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  TimePeriod,
} from "app/shared";
import { ChartDefinitions, ChartDefinition } from "../../../chartDefinitions.config";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { ManualsUpdatedConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "manuals-updated-details",
  templateUrl: "./manuals-updated-details.component.html",
  standalone: false,
})
export class ManualsUpdatedDetailsComponent
  extends BaseDetailsLogic<ManualsUpdatedConfig>
  implements OnInit, OnDestroy
{

  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, ManualsUpdatedConfig, tooltipCoordinator);
  }

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
      this.detectSettingsChange();
      this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      timePeriod: 'Pick a time period to see which manuals were updated during that time. For example, you can look at manuals updated in the last week, month, or year. This helps you understand when changes were made to your manuals.'
    };
  }
}
